'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bookHealthCheckModal = require('../../src/styles/book-health-check-modal.scss');

var _bookHealthCheckModal2 = _interopRequireDefault(_bookHealthCheckModal);

require('../../src/styles/external.scss');

var _doctifyModal = require('./doctify-modal');

var _doctifyModal2 = _interopRequireDefault(_doctifyModal);

var _bookHealthCheck = require('../../../book-health-check');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import messages from '../lang/default-messages';

// import { FormattedMessage } from 'react-intl';

var BookHealthCheckModal = function BookHealthCheckModal(props) {
	return _react2.default.createElement(
		_doctifyModal2.default,
		{
			className: _bookHealthCheckModal2.default.modalContainer + ' ' + props.className,
			bodyStyles: _bookHealthCheckModal2.default.body,
			header: props.submitSuccessful ? _react2.default.createElement(
				'span',
				{ className: _bookHealthCheckModal2.default.headerLarge + ' ' + _bookHealthCheckModal2.default.green },
				_react2.default.createElement('i', { className: 'ion-ios-checkmark-outline' }),
				'Thanks'
			) : _react2.default.createElement(
				'span',
				null,
				'Enquire About ',
				props.title
			),
			closeModal: props.closeModal },
		!props.submitSuccessful && _react2.default.createElement(_bookHealthCheck.BookHealthCheck, props)
		// There is no point to BookHealthCheck being its own component in my opinion - let alone its own repo.
		// TODO: Move BookHealthCheck jsx to this component.
		,
		props.submitSuccessful && _react2.default.createElement(
			'div',
			{ className: _bookHealthCheckModal2.default.successScreen },
			_react2.default.createElement(
				'p',
				null,
				'Your enquiry has been sent.'
			),
			_react2.default.createElement(
				'button',
				{ className: 'btn solid practice',
					onClick: props.closeModal },
				'Close'
			)
		)
	);
};

BookHealthCheckModal.propTypes = {
	title: require('react').PropTypes.any.isRequired,
	account: require('react').PropTypes.object.isRequired,
	requestData: require('react').PropTypes.object.isRequired,
	onFirstNameChange: require('react').PropTypes.func.isRequired,
	onLastNameChange: require('react').PropTypes.func.isRequired,
	onEmailChange: require('react').PropTypes.func.isRequired,
	onGenderChange: require('react').PropTypes.func.isRequired,
	onPhoneChange: require('react').PropTypes.func.isRequired,
	onReasonForVisitChange: require('react').PropTypes.func.isRequired,
	onPromoCodeChange: require('react').PropTypes.func.isRequired,
	onValidatePromoCode: require('react').PropTypes.func.isRequired,
	onSubmit: require('react').PropTypes.func.isRequired,
	closeModal: require('react').PropTypes.func.isRequired,
	submitSuccessful: require('react').PropTypes.any.isRequired,
	className: require('react').PropTypes.any.isRequired
};
BookHealthCheckModal.displayName = 'BookHealthCheckModal';

BookHealthCheckModal.defaultProps = {
	title: 'health check',
	account: {}
};

exports.default = BookHealthCheckModal;


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/components/book-health-check-modal.js